import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { Flex } from "../Flex";
import { Typography } from "../Typography";
import { SelectItem } from "./Item";
import { ReactSelect, StyledSelectItem } from "./styles";
export default function ReactSelectComponent({ name, size, value, isOpen, loading, waiting, isMulti, disabled, lazyRender, searchable, placeholder: camePlaceholder, massiveLabel, checkedFirst, feedbackType, hasPermission, orderedOptions: cameOrderedOptions, lazyRenderAmount = 20, massiveSelectOption, setIsOpen, handleClearValue, handleValueChange, selectedValuesRender, }) {
    const reactSelectRef = useRef(null);
    const orderedOptions = useMemo(() => [...cameOrderedOptions], [cameOrderedOptions]);
    const [inputSearch, setInputSearch] = useState('');
    const placeholder = `${camePlaceholder}${searchable ? ' ou pesquisar' : ''}`;
    const currentValue = orderedOptions.filter((item) => {
        if (Array.isArray(value))
            return value.includes(item.value);
        return item.value === value;
    });
    const isAllSelected = value?.length === cameOrderedOptions.length;
    const [lazyOptions, setLazyOptions] = useState([]);
    const options = useMemo(() => {
        let parsedOptions = orderedOptions;
        if (lazyRender)
            parsedOptions = lazyOptions;
        if (checkedFirst && !isOpen && !isAllSelected && isMulti)
            parsedOptions = parsedOptions.sort((a, b) => {
                if (value?.includes(a.value))
                    return -1;
                if (value?.includes(b.value))
                    return 1;
                return 0;
            });
        if (massiveSelectOption && !inputSearch && isMulti && parsedOptions.length > 1) {
            parsedOptions = [
                {
                    label: massiveLabel || 'Selecionar todas',
                    value: 'MASSIVE_ACTION'
                },
                ...parsedOptions
            ];
        }
        if (!isMulti) {
            parsedOptions = parsedOptions.changePosition(parsedOptions.findIndex((item) => item.value === value), 0);
        }
        return parsedOptions;
    }, [lazyRender, lazyOptions, inputSearch, isOpen, checkedFirst]);
    const getInputElement = () => document.querySelector(`#select-input-${name}`);
    const onAfterMenuOpen = () => {
        setIsOpen(true);
        if (searchable) {
            setTimeout(() => {
                getInputElement()?.focus?.();
            }, 100);
        }
    };
    const onAfterMenuClose = () => {
        setIsOpen(false);
        if (lazyRender)
            setLazyOptions((prevState) => prevState.splice(0, lazyRenderAmount));
    };
    const handleLazyPushOptions = () => {
        if (lazyOptions.length === orderedOptions.length || !lazyRender)
            return;
        setLazyOptions((prev) => {
            const next = [
                ...prev,
                ...orderedOptions
                    .slice(prev.length - lazyRenderAmount, prev.length + lazyRenderAmount)
            ];
            return next;
        });
    };
    const components = {
        MultiValue: (data) => {
            const render = !data.index;
            return render && !getInputElement()?.value && !inputSearch ? (_jsx(Flex, { position: "absolute", cursor: "text", onClick: onAfterMenuOpen, as: Typography, color: "--text-disable", textEllipsis: 1, title: placeholder, children: placeholder })) : null;
        },
        Option: ({ data }) => {
            const { value: optionValue, label: optionLabel } = data;
            return (_jsx(SelectItem, { onUnSelectOption: handleClearValue, selectedValue: value, value: optionValue, disabled: disabled, label: optionLabel, isMulti: isMulti, isAllSelected: isAllSelected, onClick: () => {
                    if (optionValue === value)
                        return;
                    if (!isMulti) {
                        handleValueChange(optionValue);
                        reactSelectRef.current?.blur();
                        return;
                    }
                    if (optionValue === 'MASSIVE_ACTION') {
                        handleValueChange(optionValue, isAllSelected ? 'CLEAR' : 'ADD_ALL');
                        return;
                    }
                    handleValueChange(optionValue, value?.includes(optionValue) ? 'REMOVE' : 'ADD_SINGLE');
                } }));
        },
        NoOptionsMessage: () => (_jsx(StyledSelectItem, { value: "empty", disabled: true, children: _jsx(Flex, { width: "100%", justifyContent: "center", padding: "4px", children: _jsx(Typography, { variant: "Paragraph/Regular", align: "center", children: "Sem op\u00E7\u00F5es" }) }) })),
    };
    if (isMulti && !isOpen) {
        components.ValueContainer = () => {
            const selectedValuesComponent = selectedValuesRender?.(value);
            return (_jsx(Flex, { onClick: onAfterMenuOpen, width: "100%", title: selectedValuesComponent || placeholder, as: Typography, color: selectedValuesComponent ? undefined : "--text-disable", textEllipsis: 1, children: selectedValuesComponent || placeholder }));
        };
    }
    useEffect(() => {
        if (lazyRender)
            setLazyOptions(orderedOptions.splice(0, lazyRenderAmount));
    }, [orderedOptions]);
    return (_jsx(ReactSelect, { id: name, name: name, options: options, placeholder: placeholder, isDisabled: disabled || !hasPermission || waiting || loading, "data-testid": `select-${name}-trigger`, hideSelectedOptions: false, blurInputOnSelect: !isMulti, closeMenuOnSelect: !isMulti, menuIsOpen: isOpen, openMenuOnFocus: true, feedback: feedbackType, isSearchable: searchable, isMulti: isMulti, onBlur: onAfterMenuClose, inputId: `select-input-${name}`, openMenuOnClick: true, onMenuScrollToBottom: handleLazyPushOptions, inputValue: inputSearch, onInputChange: setInputSearch, onMenuOpen: onAfterMenuOpen, onMenuClose: onAfterMenuClose, isClearable: false, ref: reactSelectRef, size: size, value: currentValue, components: components, unstyled: true }));
}
//# sourceMappingURL=ReactSelectComponent.js.map